import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//styles
import { LiveReportLayout } from "./styles";
import { losses } from "./components/perfTestData";
// components
import {
  LiveReportHeader,
  LiveReportFooter,
  ReportTitle,
  InfoBoxes,
  LiveReportMap,
  RackingTable,
  TrackerBreakdownTable,
  LayoutTable,
  ModuleTable,
  PerformanceTable,
  InverterTable,
  BOMTable,
  IAMGraph,
  IAMTable,
  BatteryStorageGraph,
  SoilingAlbedoTable,
  PerformanceSummaryTable,
  WindAndTemp,
  EArrayEGridGraph,
  PerfGraph,
  LossTable,
  InverterEffGraph,
  TopoMap,
  TopoScaleView,
  TopoLossTable,
  BatterStorageTable,
} from "./components";
import { Spin } from "../BaseComponents";
import { siftActions } from "..";

import { LiveReportMapboxMap } from "..";

//product images
//import { dahlia_fuse, glide_front, glide_rear, terratrack } from "../../assets/images";

const LiveReport = ({ addMapRefs, loadingLayout, captureGraphImage }) => {
  const dispatch = useDispatch();

  const reportData = useSelector((state) => state.sift.ioManager.report.reportData);

  useEffect(() => {
    console.log("report Data", reportData);
  }, [reportData]);

  useEffect(() => {
    if (!loadingLayout) {
      let pageLength = reportData.topo_id ? 15 : document.querySelectorAll(".page-wrap").length;
      dispatch(siftActions.updateReportData("numOfPages", pageLength));
    }
  }, [loadingLayout]);

  // const getProductImage = (product = undefined) => {
  //   // switch (reportData.racking_name) {
  //   // console.log("product", product);
  //   const productImages = {
  //     "Terrasmart GLIDE Fuse": dahlia_fuse,
  //     "Terrasmart TerraTrak": terratrack,
  //     "Terrasmart GLIDE Wave": glide_front,
  //     "Terrasmart GLIDE Agile": glide_rear,
  //   };
  //
  //   return productImages[product] || '';
  // };

  return (
    <section id="TheLiveReport">
      {loadingLayout && !reportData ? (
        <LiveReportLayout>
          <section className="page-wrap">
            <section className="page">
              <section className="report-loader">
                <Spin tip="Loading PDF Report..." />
              </section>
            </section>
          </section>
        </LiveReportLayout>
      ) : (
        <LiveReportLayout>
          {Object.values(reportData).length > 0 &&
            (() => {
              let pageNum = 1;
              const pages = [];

              pages.push(
                <section className="page-wrap" key="info-page">
                  <section className="page">
                    <LiveReportHeader />
                    <section className="report-rundown">
                      <ReportTitle />
                      <InfoBoxes reportData={reportData} />
                      <section className="vicinity-map">
                        <LiveReportMap mapName={"vicinityMap"} showToggles={false} addMapRefs={addMapRefs} />
                      </section>
                      <section className="layout-map">
                        <LiveReportMapboxMap mapName={"layoutMap"} showToggles={true} addMapRefs={addMapRefs} />
                      </section>
                    </section>
                    <LiveReportFooter designation={"A001"} pageNum={pageNum++} />
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="big-map-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader />
                    </section>
                    <section className="large-layout-map">
                      <LiveReportMapboxMap mapName={"largeLayoutMap"} showToggles={true} addMapRefs={addMapRefs} />
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"A002"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="racking-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader />
                    </section>
                    <section className="page-content">
                      <section className="title">
                        <h3>Racking</h3>
                      </section>
                      <section className="topLeft">
                        <RackingTable reportData={reportData} />
                        <TrackerBreakdownTable reportData={reportData} />
                      </section>
                      {reportData.platform === "internal_sift" && <section className="racking-image">{/* <img src={getProductImage(reportData.racking_name)} /> */}</section>}
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"B001"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="module-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader />
                    </section>
                    <section className="module-content">
                      <section className="title">
                        <h3>Module</h3>
                      </section>
                      <section className="module-table">
                        <ModuleTable reportData={reportData} />
                      </section>
                      <section className="iam-graph">
                        <IAMGraph reportData={reportData} captureGraphImage={captureGraphImage} />
                        <section className="iam-table">
                          <IAMTable reportData={reportData} />
                        </section>
                      </section>
                      {/* <section className="iam">
                  <IAMGraph reportData={reportData} />
                  <section className="iam-table">
                    <IAMTable reportData={reportData} />
                  </section>
                </section> */}
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"B002"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="inverter-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader />
                    </section>
                    <section className="page-content">
                      <section className="title">
                        <h3>Inverter</h3>
                      </section>
                      <section className="topLeft">
                        <InverterTable reportData={reportData} />
                      </section>
                      <section className="topRight">
                        <InverterEffGraph reportData={reportData} captureGraphImage={captureGraphImage} />
                      </section>
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"B003"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="performance-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader />
                    </section>
                    <section className="page-content">
                      <section className="title">
                        <h3>Performance</h3>
                      </section>
                      <section className="topLeft-perf-table ">
                        <PerformanceTable reportData={reportData} />
                        <SoilingAlbedoTable reportData={reportData} />
                      </section>
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"B004"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="layout-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader />
                    </section>
                    <section className="page-content">
                      <section className="title">
                        <h3>Layout</h3>
                      </section>
                      <section className="topLeft">
                        <LayoutTable reportData={reportData} />
                      </section>
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"B005"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="bom-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                    </section>
                    <section className="page-content">
                      <section className="title">
                        <h3>Bill of Materials</h3>
                      </section>
                      <section className="topLeft">
                        {reportData?.rack_breakdown && <BOMTable reportData={reportData} />}
                        <p>*Bill of materials is presented here for budgetary and general guidance purposes only.</p>
                      </section>
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"R001"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              pages.push(
                <section className="page-wrap" key="perf-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                    </section>
                    <section className="perf-results">
                      <h3>Performance Results</h3>
                      <section className="perf-table">
                        <PerformanceSummaryTable reportData={reportData} />
                      </section>
                      <section className="wind-graph">
                        <WindAndTemp reportData={reportData} captureGraphImage={captureGraphImage} />
                      </section>
                      <section className="eArray-graph">
                        <EArrayEGridGraph reportData={reportData} captureGraphImage={captureGraphImage} />
                      </section>
                      <section className="perf-graph">
                        <PerfGraph reportData={reportData} captureGraphImage={captureGraphImage} />
                      </section>
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"R002"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              if (reportData.en_battery === 1 && Object.values(reportData.battery_storage_results).length > 0) {
                pages.push(
                  <section className="page-wrap" key="battery_page">
                    <section className="page">
                      <section className="report-header">
                        <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                      </section>
                      <section className="page-content">
                        <section className="title">
                          <h3>Battery Storage</h3>
                        </section>
                        <section className="topLeft">{reportData?.battery_storage_results && <BatterStorageTable reportData={reportData} />}</section>
                        <section className="battery-graph">
                          <BatteryStorageGraph reportData={reportData.battery_storage_results.storage_sample_data} captureGraphImage={captureGraphImage} />
                        </section>
                      </section>
                      <section className="report-footer">
                        <LiveReportFooter designation={"S001"} pageNum={pageNum++} />
                      </section>
                    </section>
                  </section>
                );
              }

              pages.push(
                <section className="page-wrap margin-vert" key="loss-page">
                  <section className="page">
                    <section className="report-header">
                      <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                    </section>
                    <section className="page-content">
                      <section className="title">
                        <h3>Loss Tables</h3>
                      </section>
                      <section className="left-column">
                        <LossTable reportData={reportData} losses={losses} />
                      </section>
                      <section className="bifacial-column">{reportData.en_bifacial === 1 && <LossTable reportData={reportData} bifacial={true} losses={losses} />}</section>
                      <section className="bifacial-column">{Object.values(reportData.summary?.topo_impact).length > 0 && <TopoLossTable reportData={reportData} />}</section>
                    </section>
                    <section className="report-footer">
                      <LiveReportFooter designation={"R004"} pageNum={pageNum++} />
                    </section>
                  </section>
                </section>
              );

              if (reportData?.topo_id) {
                // Elevation Page (Ungraded & optional Graded)
                pages.push(
                  <section className="page-wrap margin-vert" key="topo-elevation">
                    <section className="page">
                      <section className="report-header">
                        <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                      </section>
                      <section className="topo-content">
                        <section className="topo-container">
                          <section className="topo-title">
                            <h3>Elevation (Ungraded)</h3>
                          </section>
                          <section className="topo-map">
                            <TopoMap mapName="ele" topoMode="ele" setLiveReportMapRefs={addMapRefs} />
                          </section>
                          <section className="topo-scale">
                            <TopoScaleView name="topo_scale_ele" topo_id={reportData.topo_id} mode="ele" setLiveReportMapRefs={addMapRefs} />
                          </section>
                        </section>

                        {reportData.vis_ele_graded_avail && (
                          <section className="topo-container">
                            <section className="topo-title">
                              <h3>Elevation (Graded)</h3>
                            </section>
                            <section className="topo-map">
                              <TopoMap mapName="ele-g" topoMode={`ele/G/${reportData.vis_ele_graded_percent}`} setLiveReportMapRefs={addMapRefs} />
                            </section>
                            <section className="topo-scale">
                              <TopoScaleView name="topo_scale_ele-g" topo_id={reportData.topo_id} mode={`ele/G/${reportData.vis_ele_graded_percent}`} setLiveReportMapRefs={addMapRefs} />
                            </section>
                          </section>
                        )}
                      </section>
                      <section className="report-footer">
                        <LiveReportFooter pageNum={pageNum++} designation="T001" />
                      </section>
                    </section>
                  </section>
                );

                // Cut and Fill Page
                if (reportData?.vis_g?.graded_avail) {
                  pages.push(
                    <section className="page-wrap margin-vert" key="topo-cut-fill">
                      <section className="page">
                        <section className="report-header">
                          <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                        </section>
                        <section className="topo-content">
                          <section className="topo-container">
                            <section className="topo-title">
                              <h3>Cut and Fill</h3>
                            </section>
                            <section className="topo-map">
                              <TopoMap mapName="CF" topoMode={`CF/${reportData.vis_g.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                            </section>
                            <section className="topo-scale">
                              <TopoScaleView name="topo_scale_CF" topo_id={reportData.topo_id} mode={`CF/${reportData.vis_g.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                            </section>
                          </section>
                        </section>
                        <section className="report-footer">
                          <LiveReportFooter pageNum={pageNum++} designation="T002" />
                        </section>
                      </section>
                    </section>
                  );
                }

                // Max Slope Page
                if (reportData.vis_max?.ungraded_avail || reportData.vis_max?.graded_avail) {
                  pages.push(
                    <section className="page-wrap margin-vert" key="topo-max-slope">
                      <section className="page">
                        <section className="report-header">
                          <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                        </section>
                        <section className="topo-content">
                          {reportData.vis_max?.ungraded_avail && (
                            <section className="topo-container">
                              <section className="topo-title">
                                <h3>Max Slope (Ungraded)</h3>
                              </section>
                              <section className="topo-map">
                                <TopoMap mapName="U" topoMode={`U/${reportData.vis_max.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                              <section className="topo-scale">
                                <TopoScaleView name="topo_scale_U" topo_id={reportData.topo_id} mode={`U/${reportData.vis_max.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                            </section>
                          )}
                          {reportData.vis_max?.graded_avail && (
                            <section className="topo-container">
                              <section className="topo-title">
                                <h3>Max Slope (Graded)</h3>
                              </section>
                              <section className="topo-map">
                                <TopoMap mapName="U-G" topoMode={`U/G/${reportData.vis_max.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                              <section className="topo-scale">
                                <TopoScaleView name="topo_scale_U-G" topo_id={reportData.topo_id} mode={`U/G/${reportData.vis_max.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                            </section>
                          )}
                        </section>
                        <section className="report-footer">
                          <LiveReportFooter pageNum={pageNum++} designation="T003" />
                        </section>
                      </section>
                    </section>
                  );
                }

                // NS Grade Page
                if (reportData.vis_ns?.ungraded_avail || reportData.vis_ns?.graded_avail) {
                  pages.push(
                    <section className="page-wrap margin-vert" key="topo-ns">
                      <section className="page">
                        <section className="report-header">
                          <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                        </section>
                        <section className="topo-content">
                          {reportData.vis_ns.ungraded_avail && (
                            <section className="topo-container">
                              <section className="topo-title">
                                <h3>NS Grade (Ungraded)</h3>
                              </section>
                              <section className="topo-map">
                                <TopoMap mapName="NS" topoMode={`NS/${reportData.vis_ns.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                              <section className="topo-scale">
                                <TopoScaleView name="topo_scale_NS" topo_id={reportData.topo_id} mode={`NS/${reportData.vis_ns.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                            </section>
                          )}
                          {reportData.vis_ns.graded_avail && (
                            <section className="topo-container">
                              <section className="topo-title">
                                <h3>NS Grade (Graded)</h3>
                              </section>
                              <section className="topo-map">
                                <TopoMap mapName="NS-G" topoMode={`NS/G/${reportData.vis_ns.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                              <section className="topo-scale">
                                <TopoScaleView name="topo_scale_NS-G" topo_id={reportData.topo_id} mode={`NS/G/${reportData.vis_ns.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                            </section>
                          )}
                        </section>
                        <section className="report-footer">
                          <LiveReportFooter pageNum={pageNum++} designation="T004" />
                        </section>
                      </section>
                    </section>
                  );
                }

                // EW Grade Page
                if (reportData.vis_ew?.ungraded_avail || reportData.vis_ew?.graded_avail) {
                  pages.push(
                    <section className="page-wrap margin-vert" key="topo-ew">
                      <section className="page">
                        <section className="report-header">
                          <LiveReportHeader location={reportData.location} user={reportData.userName} date={reportData.date} />
                        </section>
                        <section className="topo-content">
                          {reportData.vis_ew.ungraded_avail && (
                            <section className="topo-container">
                              <section className="topo-title">
                                <h3>EW Grade (Ungraded)</h3>
                              </section>
                              <section className="topo-map">
                                <TopoMap mapName="EW" topoMode={`EW/${reportData.vis_ew.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                              <section className="topo-scale">
                                <TopoScaleView name="topo_scale_EW" topo_id={reportData.topo_id} mode={`EW/${reportData.vis_ew.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                            </section>
                          )}
                          {reportData.vis_ew.graded_avail && (
                            <section className="topo-container">
                              <section className="topo-title">
                                <h3>EW Grade (Graded)</h3>
                              </section>
                              <section className="topo-map">
                                <TopoMap mapName="EW-G" topoMode={`EW/G/${reportData.vis_ew.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                              <section className="topo-scale">
                                <TopoScaleView name="topo_scale_EW-G" topo_id={reportData.topo_id} mode={`EW/G/${reportData.vis_ew.ungraded_percent}`} setLiveReportMapRefs={addMapRefs} />
                              </section>
                            </section>
                          )}
                        </section>
                        <section className="report-footer">
                          <LiveReportFooter pageNum={pageNum++} designation="T005" />
                        </section>
                      </section>
                    </section>
                  );
                }
              }
              return pages;
            })()}
        </LiveReportLayout>
      )}
    </section>
  );
};

export { LiveReport };
